import { render, staticRenderFns } from "./GoodsNorms.vue?vue&type=template&id=e515a0e2&"
import script from "./GoodsNorms.vue?vue&type=script&lang=js&"
export * from "./GoodsNorms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports